import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Listing} from '../../../../classes/listing';
import {SearchResult} from '../../search-bar.component';
import {ListingsService} from '../../../../services/listings.service';

@Component({
  selector: 'app-mls-result',
  templateUrl: './mls-result.component.html',
  styleUrls: ['./mls-result.component.scss']
})
export class MlsResultComponent implements OnInit {
  @Input() result: SearchResult;
  @Output() selectResult: EventEmitter<SearchResult> = new EventEmitter();
  @Output() favouriteClick: EventEmitter<Listing> = new EventEmitter();
  @Output() onBlur: EventEmitter<void> = new EventEmitter();  

  priceOrPricePerSqFt: string;

  constructor(private listingService: ListingsService) { }
  
  ngOnInit() {
    this.setPriceOrPricePerSqFt();
  }

  setPriceOrPricePerSqFt() {
    this.listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(str => this.priceOrPricePerSqFt = str);
  }

  get listing(): Listing {
    if (this.result.data instanceof Listing) {
      return this.result.data;
    } else {
      return new Listing(this.result.data);
    }
  }

  onFavouriteClick($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.listing.isFavourite = !this.listing.isFavourite;
    this.favouriteClick.emit(this.listing);
  }


}
